import {ChangeDetectionStrategy, Component, Input, OnInit, Optional} from '@angular/core';
import {NbDialogRef} from '@nebular/theme';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {nameCharactersValidator} from '@theme/validators/name-characters.validator';
import {AlertMessageVariant} from '@theme/components/ui/alert-message-inline/alert-message-inline.component';

@Component({
    selector: 'ngx-submit-with-comment',
    templateUrl: './submit-with-comment.component.html',
    styleUrls: ['./submit-with-comment.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SubmitWithCommentComponent implements OnInit {
    @Input() title: string = 'Add Comment';
    @Input() label?: string;
    @Input() confirmIcon: string = 'checkmark-circle-2-outline';
    @Input() confirmText: string = 'Submit';
    @Input() cancelText: string = 'Cancel';
    @Input() required: boolean = true;
    @Input() maxLength?: number;
    @Input() message?: string;
    @Input() alertMessage?: string;
    @Input() alertStatus: AlertMessageVariant = 'info';

    public form: FormGroup = this.fb.group({
        comment: [''],
    });

    firstSaveFormTrigger: boolean = false;

    constructor(@Optional() private dialogRef: NbDialogRef<any>, private fb: FormBuilder) {}

    public ngOnInit() {
        if (this.required) this.form.get('comment').addValidators(Validators.required);
        if (this.maxLength) this.form.get('comment').addValidators(Validators.maxLength(this.maxLength));
        this.form.updateValueAndValidity();
    }

    close() {
        this.dialogRef.close();
    }

    save() {
        if (this.form.invalid) {
            this.firstSaveFormTrigger = true;
            this.form.markAllAsTouched();
            return;
        } else {
            this.dialogRef.close({comment: this.form.value.comment});
        }
    }
}
